import { useTranslation } from 'react-i18next';
import type { Kpi } from '@interfaces/IKpi';
import { KpiTile } from './KpiTile/KpiTile';
import styles from './styles.module.css';

type IKpiStripProps = { kpis: Kpi[] };

export function KpiStrip({ kpis }: IKpiStripProps) {
  const { t } = useTranslation();
  return (
    <section className={styles.strip} aria-label={t('portfolio.kpis.ariaLabel')}>
      {kpis.map((k) => (
        <KpiTile key={k.label} k={k} />
      ))}
    </section>
  );
}
